import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ImpactHeaderComponent} from "./impact-header.component";


@NgModule({
  declarations: [ImpactHeaderComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [ImpactHeaderComponent]
})
export class ImpactHeaderModule {
}
